import { Tag, Tooltip } from "antd"
import { useContext } from "react"
import { InvoiceSummary } from "../../../domain/invoicing/invoice"
import { isInvoiceExportedToQuickBooks } from "../../../domain/invoicing/quickBooksTrackingModel"
import { AuthenticationContext } from "../../../AuthenticationContext"

type Props = {
  invoiceSummary: InvoiceSummary
}

const QuickBooksTrackingState = ({ invoiceSummary }: Props) => {
  const { currentUser } = useContext(AuthenticationContext)
  const isTenantConnectedToQuickBooks = currentUser?.isTenantConnectedToQuickBooks === true

  if (!isTenantConnectedToQuickBooks && invoiceSummary.invoicingSystem !== 'quickBooks') {
    return <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>—</span>
  }

  if (invoiceSummary.invoicingSystem === 'quickBooks') {
    return <Tag color="success">Synced</Tag>
  }

  const isInvoiceExported = isInvoiceExportedToQuickBooks(invoiceSummary)
  const isSynced = isInvoiceExported && !invoiceSummary.hasUnexportedPayment

  if (isSynced) {
    return <Tag color="success">Synced</Tag>
  }

  const tooltipText = getTooltipText(!isInvoiceExported, invoiceSummary.hasUnexportedPayment)
  return (
    <Tooltip title={tooltipText}>
      <Tag color="error">Not Synced</Tag>
    </Tooltip>
  )
}

const getTooltipText = (invoiceNotExported: boolean, paymentNotExported: boolean): string => {
  if (invoiceNotExported && paymentNotExported) {
    return "This invoice and associated payment have not been tracked in QuickBooks."
  }
  if (invoiceNotExported) {
    return "This invoice has not been tracked in QuickBooks."
  }
  return "The payment for this invoice has not been tracked in QuickBooks."
}

export default QuickBooksTrackingState
